var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"am-input-textarea",class:[
		{
			'is-focused': _vm.focused
		}
	]},[_c('textarea',{staticClass:"am-input-textarea__field",attrs:{"placeholder":_vm.label},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"keydown":function($event){return _vm.$emit('keydown', $event)},"keyup":function($event){return _vm.$emit('keyup', $event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }